import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BookOpenIcon } from '@heroicons/react/24/outline';
import UserMenu from './UserMenu';
import CreditsBalance from './CreditsBalance';
import NotificationCenter from '../NotificationCenter/NotificationCenter';
import TutorialSlideshow from '../TutorialSlideshow/TutorialSlideshow';
import { useAuth } from '../../contexts/AuthContext';

export default function Navigation() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [showTutorialModal, setShowTutorialModal] = useState(false);
  return (
    <nav className="bg-white shadow-sm">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 justify-between items-center">
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-2">
              <BookOpenIcon className="h-8 w-8 text-indigo-600" />
              <span className="text-xl font-bold text-gray-900 whitespace-nowrap">Storybook Wizard</span>
            </Link>
          </div>
          
          <div className="flex items-center space-x-6">
            <CreditsBalance />
            <button
              onClick={() => setShowTutorialModal(true)}
              className="px-3 py-2 rounded-md bg-yellow-100 text-yellow-900 hover:bg-yellow-200 font-medium text-sm"
            >
              Tutorial
            </button>
            {user && (
              <button
                onClick={() => navigate('/account/credits')}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Buy Credits
              </button>
            )}
            <NotificationCenter />
            <UserMenu />
          </div>
        </div>
      </div>

      {/* Tutorial Modal */}
      {showTutorialModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-7xl w-full max-h-[90vh] overflow-auto">
            <div className="flex justify-between items-center px-6 py-3 border-b border-gray-200 sticky top-0 bg-white">
              <h2 className="text-lg font-bold text-gray-900">Tutorial</h2>
              <button
                onClick={() => setShowTutorialModal(false)}
                className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
                aria-label="Close tutorial"
              >
                ✕
              </button>
            </div>
            <div className="px-6 py-4">
              <TutorialSlideshow />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}